import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button, Link, Stack} from '@customink/pigment-react';
import {useNavigate} from 'react-router-dom';

import {removeAll} from '~/actions/NamesAndNumbersActions';
import {useDispatch} from 'react-redux';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function IncompatibleNamesAndNumbersNotification({
  dismiss,
  ...props
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const goToProductCatalog = () => {
    navigate('/productCatalog');
    dismiss();
  };

  const removeNamesAndNumbers = () => {
    dispatch(removeAll());
    dismiss();
  };

  return (
    <Notification {...props} title="Names and numbers not supported">
      <p className="ndx-cta1">
        This product does not support names and numbers. By continuing, these
        will be removed from your design.
      </p>
      <Stack className="notification-stack">
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={removeNamesAndNumbers}>
          Continue
        </Button>
        <p className="ndx-cta1">
          or <Link onClick={goToProductCatalog}>go back</Link>.
        </p>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

IncompatibleNamesAndNumbersNotification.propTypes = propTypes;

IncompatibleNamesAndNumbersNotification.displayName =
  'IncompatibleNamesAndNumbersNotification';
